var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "MyAdvisorRetirement mark",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 7,
    x2: 0,
    y2: 95
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4A7FD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#699DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FB38A"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 13,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,63V79",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.33,76.69A29,29 0 1 0 16.24,66.63",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.59,94.17A45,45 0 0 0 34.52,5.34",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#FFFFFF",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarMarkWhite);
export default __webpack_public_path__ + "static/media/mar-mark-white.2e47e16dc969b6612b3c2991d018b39b.svg";
export { ForwardRef as ReactComponent };